module.exports = __webpack_public_path__ + "static/taste-of-boba-tea-success-452216341f82e14b06bd585367d53eb1.jpg";